import React, { useState } from 'react';
import { t } from '../../../../../i18n';
import './styles.scss';

const ActivationCodeInput = ({ onCodeEntered, initialCode }) => {
  const [value, setValue] = useState(() => {
    const initialValue = ['', '', '', '', '-', '', '', '', '', '-', '', '', '', ''];
    for (let i = 0; i < initialCode?.length ?? 0; i++) {
      initialValue[i] = initialCode[i];
    }
    return initialValue;
  });

  const focusCharacterInput = charIndex => {
    if (charIndex < 0 || charIndex >= value.length) {
      return;
    }
    document.getElementById('activationCode' + charIndex).focus();
  };

  const handleValueChange = newValue => {
    setValue(newValue);
    if (newValue.every(c => c)) {
      onCodeEntered(newValue.join(''));
    } else {
      onCodeEntered('');
    }
  };

  const handleCharacterChange = (characterIndex, character) => {
    const newValue = [...value];
    newValue[characterIndex] = character;
    handleValueChange(newValue);
  };

  return (
    <div className="gift-card-activation-code">
      <label htmlFor="activationCode0">{t('DIGITAL_COURSES.GIFT_CARD_REDEEM.ENTER_CODE')}</label>
      <div className="gift-card-activation-code__row">
        {value.map((character, characterIndex) => {
          if (character === '-') {
            return (
              <span key={characterIndex} className="gift-card-activation-code__dash">
                &#8212;
              </span>
            );
          }
          return (
            <input
              id={'activationCode' + characterIndex}
              className="gift-card-activation-code__input"
              key={characterIndex}
              value={character}
              onKeyDown={e => {
                if (e.key === 'ArrowLeft') {
                  let previousCharIndex = characterIndex - 1;
                  if (value[previousCharIndex] === '-') {
                    previousCharIndex--;
                  }
                  focusCharacterInput(previousCharIndex);
                  return;
                }
                if (e.key === 'ArrowRight') {
                  let nextCharIndex = characterIndex + 1;
                  if (value[nextCharIndex] === '-') {
                    nextCharIndex++;
                  }
                  focusCharacterInput(nextCharIndex);
                  return;
                }
                if (e.key === 'Escape') {
                  e.target.blur();
                  return;
                }
                if (e.key === 'Backspace') {
                  e.preventDefault();
                  if (character === '' && characterIndex > 0) {
                    let previousCharIndex = characterIndex - 1;
                    if (value[previousCharIndex] === '-') {
                      previousCharIndex--;
                    }
                    handleCharacterChange(previousCharIndex, '');
                    focusCharacterInput(previousCharIndex);
                    return;
                  }
                  handleCharacterChange(characterIndex, '');
                }
              }}
              onChange={e => {
                let newText = e.target.value.replace(/[^A-Z0-9]+/gi, '').toUpperCase();
                if (!newText) {
                  return;
                }
                if (character && newText.substring(characterIndex).startsWith(character)) {
                  newText = newText.substring(1);
                }
                const newValue = [...value];
                for (let i = characterIndex, j = 0; i < value.length && j < newText.length; i++, j++) {
                  if (value[i] === '-') {
                    i++;
                  }
                  newValue[i] = newText[j];
                }

                handleValueChange(newValue);

                let nextCharacterIndex = characterIndex + e.target.value.length;
                if (value[nextCharacterIndex] === '-') {
                  nextCharacterIndex++;
                }
                if (nextCharacterIndex >= value.length) {
                  e.target.blur();
                  return;
                }
                focusCharacterInput(nextCharacterIndex);
              }}
              autoComplete="off"
            />
          );
        })}
      </div>
    </div>
  );
};
export default ActivationCodeInput;
